module.exports = __webpack_public_path__ + "img/pic.d83f40ad.png";